export default __webpack_public_path__ + "static/media/logo.df534764.webp";